import React from 'react';
import { Toast } from '@fincity-frontend/shared-ui';
import {
  webSocketUrl,
  socketTopic,
  notificationWhatsAppTopic,
  notificationCount
} from 'gatsby-env-variables';
import notification from '../../Audio/notification/notification_call.mp3';
import { isAliveWebSocket } from './WebSocket';
import DescriptionTwoToneIcon from '@material-ui/icons/DescriptionTwoTone';
import { setSocketMessage } from '../../pages/app';

export const actionOnMessage = data => {
  let message = null;

  try {
    message = JSON.parse(data?.body || {});
  } catch {
    message = '';
  }
  if (!message) return;

  if (message?.messageType != 'unread_notification_count') {
    const audio = new Audio(notification);
    audio.play();
  }

  if (typeof setSocketMessage == 'function') {
    setSocketMessage(message);
  }
  const excludeData = ['/app/whatsapp'];

  if (message.messageType === 'applicant_whatsapp_notification') {
    if (
      excludeData?.includes(
        `${window?.location?.pathname}${window?.location?.search}`
      )
    )
      return;
    Toast(
      'info',
      <div className="block px-2 py-1 ">
        <div className="">
          <p className="pb-1  font-extrabold text-lg ">
            {message?.message || 'You have a new notification!'}
          </p>
          {`${message.whatsappMessage || ''}`}

          <div className="w-full">
            {message.isDocumentSent && (
              <div className="w-full">
                <p className="pb-1  font-normal text-basic ">
                  You recieved a new document!
                </p>
                <DescriptionTwoToneIcon className="h-32 w-full" />
              </div>
            )}
          </div>
        </div>
      </div>,
      20000
    );
    return;
  } else if (message.messageType == 'applicant_calling_notification') {
    return Toast(
      'info',
      <div className="block px-2 py-1 ">
        <p className="pb-1  font-extrabold text-lg ">
          {message?.message || 'You have a new notification!'}
        </p>
        <p className="pb-2 text-sm capitalize font-semibold">
          {message?.messageType?.replace(/_/g, ' ') ||
            'it seems something wrong from our end.'}
        </p>
      </div>,
      20000
    );
  }
};

export const socketData = ({
  token,
  socketInstance,
  onConnect,
  onDisconnect,
  onError
}) => {
  return {
    url: webSocketUrl,
    topic: socketTopic,
    notificationWhatsAppTopic: notificationWhatsAppTopic,
    notificationCount: notificationCount,
    token: token,
    onConnect: data => {},
    onDisconnect: (data, isDisconnected) => {
      try {
        if (socketInstance.reconection <= 2 && !isAliveWebSocket()) {
          socketInstance.reConnect();
        }
      } catch {}

      typeof onDisconnect == 'function' && onDisconnect(data, isDisconnected);
    },
    onError: data => {
      typeof onError == 'function' && onError(data);
    },
    onMessage: actionOnMessage
  };
};
